import React, { useRef, useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

export default function Constraint({ constraint, updatePage, updateConstraintsFilter, closePatternDetails, extraStyle = '' }) {
    const constraintRef = useRef(); // Reference to the div
    const [popoverWidth, setPopoverWidth] = useState(200); // State to store the popover width

    // Effect to set the popover width after the component renders
    useEffect(() => {
        if (constraintRef.current) {
            const width = constraintRef.current.getBoundingClientRect().width;
            setPopoverWidth(width + 2); // Update popover width dynamically
        }
    }, []); // Run when the ref changes

    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement='bottom'
            overlay={
                <Popover
                    id='constraint-popover'
                    style={{
                        maxWidth: '100%',
                        width: popoverWidth,
                        minWidth: 200
                    }}
                >
                    <Popover.Title>
                        {constraint.constraint_title}
                    </Popover.Title>
                    <Popover.Content>
                        {constraint.constraint_description}
                    </Popover.Content>
                </Popover>
            }
        >
            <div
                key={"pattern-constraint-" + constraint.constraint_id}
                id={"pattern-constraint-" + constraint.constraint_id}
                className={`constraint clickable ${extraStyle} truncate`}
                onClick={() => {
                    updateConstraintsFilter && updateConstraintsFilter([constraint.constraint_id]);
                    updatePage && updatePage(0);
                    closePatternDetails && closePatternDetails(null);
                }}
                ref={constraintRef} // Assign the ref here
            >
                <b>{constraint.constraint_title}</b> - {constraint.constraint_description}
            </div>
        </OverlayTrigger>
    );
}
